import * as type from '../actions/types';

const initialState = {
    loading: false,
    data: [],
    error: null,
}

export default function sendMessage(state = initialState, action) {
    switch (action.type) {
        case type.POST_SEND_MESSAGE_REQUESTED:
            return {
                ...state,
                loading: true,
                data: [],
            }
        case type.POST_SEND_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data,
            }
        case type.POST_SEND_MESSAGE_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}